import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo-avatar.svg'


const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "row full-width items-center justify-between q-mb-sm" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-3 avatar-col" }
const _hoisted_5 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_picture_drop = _resolveComponent("picture-drop")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["profile-picture-wrapper relative-position", { editing: _ctx.editing, unpicked: !_ctx.src }])
  }, [
    (_ctx.src?.length)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: _normalizeClass(["profile-picture", { editing: _ctx.editing, smaller: !_ctx.fullSize && _ctx.editing, fullsize: _ctx.fullSize }]),
          src: _ctx.src
        }, null, 10, _hoisted_1))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: _normalizeClass(["profile-picture", { smaller: !_ctx.fullSize && _ctx.editing }]),
          src: _imports_0
        }, null, 2)),
    _createVNode(_component_q_popup_proxy, {
      class: "change-form",
      offset: [0, 0],
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "title" }, "Choose avatar", -1)),
          _createVNode(_component_d_button, {
            class: "close-avatar q-ml-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = false)),
            flat: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_close_icon, {
                size: "16px",
                left: ""
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Close", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.avatars, (avatar) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                class: "avatar",
                src: avatar,
                onClick: ($event: any) => (_ctx.updateAvatar(avatar))
              }, null, 8, _hoisted_5)
            ]))
          }), 256))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "title q-mt-md" }, "Upload your own", -1)),
        _createVNode(_component_picture_drop, {
          class: "picture-drop q-mt-md",
          logo: _ctx.uploadedPicture,
          editing: _ctx.editing,
          onChange: _ctx.onFileReceived,
          onRemoveLogo: _ctx.onUploadCleared
        }, null, 8, ["logo", "editing", "onChange", "onRemoveLogo"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}